module.exports = __webpack_public_path__ + "static/media/22ESCWA18.67fc80f5.jpg";